import * as React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export default function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Leaflit Care Inc.
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
      Artwork Attribution{" "}
      <a href="http://www.freepik.com">Designed by macrovector / Freepik</a>
    </Typography>
  );
}
